export default "__VITE_ASSET__Bdbn4_In__"